var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"small-information-list"},[_c('li',[_c('v-icon',{staticClass:"bullet-arrow"},[_vm._v(_vm._s(_vm.icons.mdiArrowRight))]),_vm._v("No email assigned yet\n  ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }